// extracted by mini-css-extract-plugin
export default {"searchContainer":"InventoryItemsTable_searchContainer__k+hNY","searchIcon":"InventoryItemsTable_searchIcon__QtjgZ"};